
export const TARGET_SRC = '/targets/hop_thanh_truc.mind';
export const PRODUCTS = {
  'SKU-000': {
    anchorIndex: 0,
    videoSrc: '/videos/Hop_Thanh_Truc.mp4',
    info: {
      tag:   'Pakgo - Trung Thu 2026',
      title: 'Xu Hướng Bao Bì Mới Nhất',
      body:  ''
    }
  },
  'SKU-001': {
    anchorIndex: 1,
    videoSrc: '/videos/Hop_Thanh_Truc.mp4',
    info: {
      tag:   'Pakgo - Trung Thu 2026',
      title: 'Xu Hướng Bao Bì Mới Nhất',
      body:  ''
    }
  }
};
